import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/mock';
import { useTheme } from '../context/ThemeContext';

const TestimonialsSection = () => {
  const { theme } = useTheme();

  return (
    <section className={`relative py-16 sm:py-20 lg:py-24 transition-colors duration-300 ${
      theme === 'dark' ? 'bg-[#0a0a0a]' : 'bg-white'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12 lg:mb-14">
          <div className={`inline-flex items-center gap-2 px-3 sm:px-4 py-2 mb-4 sm:mb-6 border ${
            theme === 'dark' ? 'border-white/20 bg-white/5' : 'border-gray-200 bg-gray-50'
          }`}>
            <span className={`text-xs sm:text-sm font-medium tracking-wide uppercase ${
              theme === 'dark' ? 'text-white/70' : 'text-gray-600'
            }`}>Testimonials</span>
          </div>
          <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            What Our Clients Say
          </h2>
          <p className={`text-base sm:text-lg max-w-[600px] mx-auto ${
            theme === 'dark' ? 'text-white/60' : 'text-gray-600'
          }`}>
            Don't just take our word for it — hear from the companies we've helped.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className={`p-5 sm:p-6 lg:p-8 transition-all duration-300 ${
                theme === 'dark' 
                  ? 'bg-black border border-white/10 hover:border-[#00FFD1]/30' 
                  : 'bg-gray-50 border border-gray-200 hover:border-[#00997A]/30 hover:shadow-md'
              }`}
            >
              <Quote className={`w-8 h-8 sm:w-10 sm:h-10 mb-4 ${
                theme === 'dark' ? 'text-[#00FFD1]/30' : 'text-[#00997A]/30'
              }`} />
              
              <p className={`text-sm sm:text-base leading-relaxed mb-5 sm:mb-6 ${
                theme === 'dark' ? 'text-white/80' : 'text-gray-700'
              }`}>
                "{testimonial.quote}"
              </p>
              
              <div className={`pt-4 sm:pt-5 border-t ${
                theme === 'dark' ? 'border-white/10' : 'border-gray-200'
              }`}>
                <p className={`font-semibold text-sm sm:text-base ${
                  theme === 'dark' ? 'text-white' : 'text-gray-900'
                }`}>
                  {testimonial.author}
                </p>
                <p className={`text-xs sm:text-sm ${
                  theme === 'dark' ? 'text-white/50' : 'text-gray-500'
                }`}>
                  {testimonial.company}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
